import React from 'react'
import { connect } from 'react-redux'
import { AppState } from '@chegg-wt/core/state/types'
import { isProSelector } from '@chegg-wt/core/state/user/selectors'
import * as Styled from './styled'

export const TOUR_PRO_HEADER_COPY = 'You have full access!'
export const TOUR_EXPERT_CHECK_COPY =
  'Receive personalized comments on your main idea, conclusion & more'
export const TOUR_CITATION_COPY = 'Create & save quick citations and works cited pages'
export const TOUR_PAPER_COPY =
  'Fix plagiarism mistakes and get advanced writing suggestions'

interface TourPanelProps {
  type: TourDashboardStep
  isPro?: boolean
}

const PaperStep = 'paper'
type PaperStepType = typeof PaperStep
const CitationStep = 'citation'
type CitationStepType = typeof CitationStep
const ExpertCheckStep = 'expert-check'
type ExpertCheckStepType = typeof ExpertCheckStep

type TourDashboardStep = PaperStepType | CitationStepType | ExpertCheckStepType

interface DashboardRenderProps {
  img: React.ReactNode
  text: string
  header: React.ReactNode
  forceTextWrap: boolean
}

const getRenderProperties = (
  type: TourDashboardStep,
  isPro: boolean
): DashboardRenderProps => {
  switch (type) {
    case ExpertCheckStep:
      return {
        img: <Styled.TourExpertCheckImg />,
        text: TOUR_EXPERT_CHECK_COPY,
        header: null,
        forceTextWrap: true,
      }
    case CitationStep:
      return {
        img: <Styled.TourCitationImg />,
        text: TOUR_CITATION_COPY,
        header: null,
        forceTextWrap: false,
      }

    case PaperStep:
    default:
      return {
        img: <Styled.TourPaperImg />,
        text: TOUR_PAPER_COPY,
        header: isPro ? (
          <Styled.TourHeader>
            <Styled.TourCelebrationImg />
            <Styled.TourHeaderText>{TOUR_PRO_HEADER_COPY}</Styled.TourHeaderText>
          </Styled.TourHeader>
        ) : null,
        forceTextWrap: false,
      }
  }
}

const TourPanel: React.FC<TourPanelProps> = ({ type, isPro }) => {
  const { img, text, header, forceTextWrap } = getRenderProperties(type, isPro)

  return (
    <Styled.TourDashboardContainer>
      {header}
      {img}
      <Styled.TourDashboardText forceTextWrap={forceTextWrap}>
        {text}
      </Styled.TourDashboardText>
    </Styled.TourDashboardContainer>
  )
}

const mapStateToProps = (state: AppState) => ({
  isPro: isProSelector(state),
})

const ConnectedTourPanel = connect(mapStateToProps)(TourPanel)

export const TourUploadWidget = <ConnectedTourPanel type={PaperStep} />
export const TourCitation = <TourPanel type={CitationStep} />
export const TourExpertCheck = <TourPanel type={ExpertCheckStep} />
